import { css } from 'styled-system/css';

export const sportsbookAsideStyle = {
	aside: css({
		base: {
			// for chatroom tab switch layout
			position: 'relative',
			display: 'flex',
			flexDirection: 'column',
			'&[data-chatroom-open="true"]': {
				'--rp-tab-switch-h': '42px',
				'& .rp-tab-switch': {
					bottom: '0',
					position: 'absolute',
					top: 'auto',
					left: '0',
					w: '375px',
					h: 'var(--rp-tab-switch-h)',
					bgColor: 'var(--body-bg)',
				},
				'& .chatroom, .video-chatroom': {
					pb: 'var(--rp-tab-switch-h)'
				},
				'& .bet-slip__badge': {
					display: 'flex' 
				}
			},
			
		}
	}),
	stickyLayout: css({
		base: {
			display: 'flex',
			flex: 1,
			flexDirection: 'column',
			'& .single-topbar': {
				position: 'fixed',
				top: '0',

			},
			'& .aside-panel': {
				minH: '206px'
			},
			'& .rp-tab-switch:nth-child(1)': {
				top: '0'
			}
		}
	}),
	asideTopbarPortal: css({
		base: {
			position: 'sticky',
			top: '0',
			zIndex: '25',
			'& .single-topbar': {
				h: '52px',
			}
		}
	}),
	promotionAside: css({
		base: {
			position: 'relative',
			overflowY: 'auto',
			display: 'flex',
			flexDirection: 'column',
			bottom: 0,
			zIndex: 2,
			marginBottom: '0',    
			w: 'var(--promotion-chatroom-width)',
			height: 'auto',
			borderRadius: '6px',
		
			'& .tab-switch': {
				top: '0px'
			},

			'& .footer': {
				pr: 'unset'
			}
		}
	}),
}